// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"more_wrapper__LkSm_","description":"more_description__aY_S5","title":"more_title__BN8VO","buttonWrapper":"more_buttonWrapper__OyV6Y"};